export const PAGE_PATHS = {
  VLE_STATS: "/vle-stats",
  COUNTRY_STATS: "/country-stats",
  UPDATE_USER_COURSE_COMPLETION: "/update-user-course-completion",
  CANDIDATE_REPORT: "/candidate-report",
  DEFAULT: "/",
  SELF_ONBOARD_USERS: "/self-onboarded-users",
  DRA_STATS: "/dra-stats",
  BCBF_STATS: "/bcbf-stats",
  PARTNER: "/partners",
  PARTNER_ONBOARD_USERS: "/bulk-onboard-users",
  ONBOARD_PARTNER: "/onboard-partner",
  PARTNER_CANDIDATES_LIST: "/partner-candidate-list",
  CREATE_ADMIN: "/create-admin",
  FREEZE_WINDOW: "/freeze-window",
  GET_PASSWORD: "/get-password",
  ADD_EXAM_DATE: "/add-exam-date",
  UPDATE_PASSWORD: "/update-password",
};
